import { getById } from 'PARENT/utilities/querySelector.js';

// Prefill the tour title in the enquiry form on the tour page
const tour_input = getById( 'enquiry-form-tour' );
if ( tour_input && Nu?.post?.title ) {
    tour_input.value = Nu.post.title;
}
